import { render, staticRenderFns } from "./PromoZaun24.vue?vue&type=template&id=7e8acb18"
import script from "./PromoZaun24.vue?vue&type=script&lang=js"
export * from "./PromoZaun24.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports